(() => {
  "use strict";
  if (window.__HP_TIB_V13_LOADED) return;
  window.__HP_TIB_V13_LOADED = true;

  const LAYER_IDS = [
    "987169",
    "996127",
    "805041",
    "410948",
    "891510",
    "377477",
    "649681",
    "223555",
    "969641",
    "267647",
    "508695",
    "278639",
    "686534",
    "306960",
    "723831",
    "391021",
    "872458",
    "980121",
    "218466",
    "471984",
    "180950",
    "487675",
    "876144",
    "743081",
    "636729",
    "266286",
    "653211",
    "460165",
    "783603",
    "778115",
    "907110",
    "884430",
    "774089",
    "442820",
    "362477",
    "519900",
    "475568",
    "694507",
    "323069",
    "322281",
    "360192",
    "714165",
    "373503",
    "888051",
    "249157",
    "736204",
    "530910",
    "992234",
    "983729",
    "154563",
    "731577",
    "470102",
    "982116",
    "948058",
    "565392",
    "692673",
    "668463",
    "939191",
    "706111",
    "982994",
    "238349",
    "406401",
    "897032",
    "284657",
    "551946",
    "805008",
    "309594",
    "706284",
    "919901",
    "959487",
    "240803",
    "844960",
    "554369",
    "652396",
    "117547",
    "384604",
    "913638",
    "114440",
    "880064"
  ];

  const FIELD_SELECTOR = LAYER_IDS.map(id => `#tee-field--layer-${id}`).join(", ");
  const FILE_INPUT_SELECTORS = LAYER_IDS.map(id => `#tee-photo-layer-${id}`).join(", ");

  const CFG = {
    fieldSelector: FIELD_SELECTOR,
    cropperRootSelector: ".tee-dialog-image-cropper",
    fakeProgressMs: 22000,
    holdPercent: 95,
    statuses: [
      "Preparing photo…",
      "Detecting subject…",
      "Refining details…",
      "Applying style…",
      "Rendering preview…",
      "Almost there…"
    ],
    confirmTextRe: /Done|bestätigen|fertig|anwenden|apply|done|ok|confirm|crop|zuschneiden|speichern|save/i,
    cancelTextRe: /abbrechen|Cancel|close|schließen|zurück|back/i,
    maxWaitMs: 60000,
    debug: false
  };

  const COPY = {
    subline: "In just a moment, you’ll see a live preview. You can upload your photo multiple times, try different photos, and compare the results instantly.",
    tipsHtml: `
      <p>The preview is shown in reduced quality. Your design will be reviewed manually and prepared for your selected product.</p>
      <p>If you have any questions, you can reach us anytime via Email.</p>
    `
  };

  const log = (...a) => CFG.debug && console.log("[HP TIB V13]", ...a);
  const qs = (sel, root=document) => root.querySelector(sel);

  const STATE = new WeakMap();
  let ACTIVE_STATE = null;
  let BYPASS_NATIVE = 0;

  function withBypass(fn){
    BYPASS_NATIVE++;
    try { return fn(); }
    finally {
      setTimeout(() => { BYPASS_NATIVE = Math.max(0, BYPASS_NATIVE - 1); }, 0);
    }
  }

  function makeState(field){
    return {
      mounted: false,
      phase: "idle",
      run: 0,
      baselineUrl: "",
      lastFinalUrl: "",
      fakeIv: null,
      pollIv: null,
      mo: null,
      slowTimeout: null,
      adjustBroken: false,
      adjustAttempt: 0,
      interceptLockUntil: 0,
      els: { field, input: null, ui: null }
    };
  }

  function normalizeUrl(u){
    if (!u) return "";
    if (u.startsWith("//")) return location.protocol + u;
    return u;
  }

  function isBadUrlForFinal(u){
    if (!u) return true;
    const s = String(u).trim();
    if (!s) return true;
    if (s.includes("loading.svg")) return true;
    if (s.startsWith("blob:")) return true;
    if (s.startsWith("data:")) return true;
    return false;
  }

  function getFieldPhotoUrl(S){
    const field = S.els.field;
    const img = field?.querySelector?.("img.tee-photo-image");
    if (!img) return "";
    const src = img.currentSrc || img.getAttribute("src") || "";
    const u = normalizeUrl(src);
    return isBadUrlForFinal(u) ? "" : u;
  }

  function hasAnyPhoto(S){
    if (S.lastFinalUrl) return true;

    const field = S.els.field;
    if (!field) return false;

    const f = S.els.input?.files?.[0];
    if (f) return true;

    const img = field.querySelector("img.tee-photo-image");
    const src = normalizeUrl(img?.currentSrc || img?.getAttribute("src") || "");
    if (src && !String(src).includes("loading.svg")) return true;

    return !!field.querySelector("button.tee-btn--recustomize");
  }

  function clearProcessing(S){
    if (S.fakeIv) { clearInterval(S.fakeIv); S.fakeIv = null; }
    if (S.pollIv) { clearInterval(S.pollIv); S.pollIv = null; }
    if (S.mo) { try { S.mo.disconnect(); } catch(e){} S.mo = null; }
    if (S.slowTimeout) { clearTimeout(S.slowTimeout); S.slowTimeout = null; }
  }

  function setPanelState(S, state){
    const p = S.els.panel;
    if (!p) return;
    p.classList.toggle("is-open", state !== "idle");
    p.classList.toggle("is-processing", state === "processing");
    p.classList.toggle("is-done", state === "done");
  }

  function setProgress(S, pct, status){
    const p = Math.max(0, Math.min(100, pct|0));
    if (status) S.els.status.textContent = status;
    S.els.pct.textContent = p + "%";
    S.els.barfill.style.width = p + "%";
  }

  function hideResult(S){
    S.els.result.hidden = true;
    S.els.img.removeAttribute("src");
  }

  function showFinal(S, url){
    const u = normalizeUrl(url);
    S.els.img.src = u + (u.includes("?") ? "&" : "?") + "hp_cache=" + Date.now();
    S.els.result.hidden = false;
    setPanelState(S, "done");
  }

  function getCropperRoot(){
    return document.querySelector(CFG.cropperRootSelector);
  }

  function looksVisible(el){
    if (!el) return false;
    const cs = window.getComputedStyle(el);
    if (!cs) return false;
    if (cs.display === "none") return false;
    if (cs.visibility === "hidden") return false;
    if (parseFloat(cs.opacity || "1") <= 0.01) return false;
    const r = el.getBoundingClientRect();
    if (!r || r.width <= 1 || r.height <= 1) return false;
    return true;
  }

  function cropperIsOpen(){
    const root = getCropperRoot();
    if (!root) return false;

    const overlay =
      root.querySelector('.vm--overlay[data-modal="tee-dialog-image-cropper"]') ||
      root.querySelector('.vm--overlay');
    const modal = root.querySelector('.vm--modal');

    const ariaOpen =
      (overlay && overlay.getAttribute("aria-expanded") === "true") ||
      (modal && modal.getAttribute("aria-expanded") === "true") ||
      (root.getAttribute && root.getAttribute("aria-expanded") === "true");

    if (ariaOpen) return true;
    if (looksVisible(overlay)) return true;
    if (looksVisible(modal)) return true;

    return false;
  }

  function fire(el){
    if (!el) return false;
    const opts = { bubbles:true, cancelable:true, view:window };
    try {
      if (window.PointerEvent) {
        el.dispatchEvent(new PointerEvent("pointerdown", { ...opts, pointerId:1, pointerType:"mouse", isPrimary:true }));
        el.dispatchEvent(new PointerEvent("pointerup", { ...opts, pointerId:1, pointerType:"mouse", isPrimary:true }));
      }
    } catch(e){}
    try { el.dispatchEvent(new MouseEvent("mousedown", opts)); } catch(e){}
    try { el.dispatchEvent(new MouseEvent("mouseup", opts)); } catch(e){}
    try { el.dispatchEvent(new MouseEvent("click", opts)); } catch(e){}
    return true;
  }

  function smartClick(el, {native=true} = {}){
    if (!el) return false;
    fire(el);
    if (native) { try { el.click(); } catch(e){} }
    return true;
  }

  function findNativeRecustomizeBtn(S){
    const field = S.els.field;
    if (!field) return null;

    let btn = field.querySelector("button.tee-btn--recustomize");
    if (btn) return btn;

    const action = field.querySelector(".tee-photo-action");
    if (action) {
      const buttons = action.querySelectorAll("button, [role='button']");
      for (const b of buttons) {
        const t = ((b.textContent || "") + " " + (b.getAttribute("aria-label") || "")).trim();
        if (/anpassen|recustomize|crop|zuschneiden|edit|adjust/i.test(t)) return b;
      }
    }
    return null;
  }

  function nativeRecustomizeUsable(S){
    const btn = findNativeRecustomizeBtn(S);
    if (!btn) return false;
    if (!btn.isConnected) return false;
    if (btn.disabled) return false;
    const aria = btn.getAttribute("aria-disabled");
    if (aria === "true") return false;
    if (btn.classList.contains("disabled") || btn.classList.contains("is-disabled")) return false;
    return true;
  }

  function scheduleAdjustSync(S, delays = [0, 120, 300, 650, 1200]){
    delays.forEach(ms => {
      setTimeout(() => {
        if (!S?.els?.field?.isConnected) return;
        syncAdjustBtn(S);
      }, ms);
    });
  }

  function canAdjustNow(S){
    if (S.phase === "processing") return false;
    if (!hasAnyPhoto(S)) return false;
    return nativeRecustomizeUsable(S);
  }

  function syncAdjustBtn(S){
    if (!S.els.adjustBtn) return;
    S.els.adjustBtn.disabled = !canAdjustNow(S);
  }

  function setIdle(S){
    S.phase = "idle";
    clearProcessing(S);
    S.adjustBroken = false;
    S.adjustAttempt++;

    try { if (S.els.input) S.els.input.value = ""; } catch(e){}

    S.els.pickBtn.disabled = false;
    S.els.pickBtnText.textContent = "Upload Photo";

    S.els.meta.hidden = false;
    S.els.fileName.textContent = "No Photo Selected";
    S.els.hint.textContent = "";

    S.els.progress.hidden = true;
    hideResult(S);
    setPanelState(S, "idle");
    setProgress(S, 0, "…");

    syncAdjustBtn(S);
    scheduleAdjustSync(S);
  }

  function setDone(S, finalUrl){
    S.phase = "done";
    clearProcessing(S);
    S.adjustBroken = false;
    S.adjustAttempt++;

    S.lastFinalUrl = finalUrl;

    S.els.pickBtn.disabled = false;
    S.els.pickBtnText.textContent = "Change Photo";

    S.els.meta.hidden = true;
    S.els.fileName.textContent = "";
    S.els.hint.textContent = "";

    S.els.progress.hidden = true;
    hideResult(S);
    setPanelState(S, "done");
    showFinal(S, finalUrl);

    syncAdjustBtn(S);
    scheduleAdjustSync(S);
  }

  function startProcessingWithBaseline(S, baseline, reason){
    if (S.phase === "processing") return;

    S.adjustBroken = false;
    S.adjustAttempt++;
    S.run++;
    const run = S.run;

    S.phase = "processing";
    clearProcessing(S);

    S.baselineUrl = baseline || S.lastFinalUrl || getFieldPhotoUrl(S) || "";
    log("startProcessing", { run, reason, baseline: S.baselineUrl });

    S.els.pickBtn.disabled = true;
    S.els.meta.hidden = true;
    syncAdjustBtn(S);

    hideResult(S);
    S.els.progress.hidden = false;

    setPanelState(S, "processing");
    setProgress(S, 1, CFG.statuses[0]);

    const total = Math.max(4000, CFG.fakeProgressMs);
    const steps = Math.max(1, CFG.statuses.length);
    const start = performance.now();

    S.fakeIv = setInterval(() => {
      if (S.run !== run || S.phase !== "processing") return;
      const elapsed = performance.now() - start;
      const p = Math.min(1, elapsed / total);
      const pct = (elapsed >= total) ? CFG.holdPercent : Math.floor(p * CFG.holdPercent);
      const stepIndex = Math.min(steps - 1, Math.floor(p * steps));
      const status = CFG.statuses[stepIndex] || CFG.statuses[steps - 1];
      setProgress(S, pct, status);
    }, 220);

    S.slowTimeout = setTimeout(() => {
      if (S.run !== run || S.phase !== "processing") return;
      S.els.status.textContent = "This is taking longer than usual… we’re on it.";
    }, CFG.maxWaitMs);

    const checkFinal = () => {
      if (S.run !== run || S.phase !== "processing") return;
      const current = getFieldPhotoUrl(S);
      if (!current) return;

      const ok =
        (!S.baselineUrl && !!current) ||
        (S.baselineUrl && current !== S.baselineUrl);

      if (!ok) return;

      setProgress(S, 100, "Done!");
      S.els.progress.hidden = true;

      S.phase = "done";
      S.lastFinalUrl = current;

      S.els.pickBtn.disabled = false;
      S.els.pickBtnText.textContent = "Change Photo";

      showFinal(S, current);
      clearProcessing(S);

      S.els.meta.hidden = true;
      syncAdjustBtn(S);
      scheduleAdjustSync(S);
    };

    S.mo = new MutationObserver(checkFinal);
    S.mo.observe(S.els.field, { subtree:true, childList:true, attributes:true, attributeFilter:["src"] });

    S.pollIv = setInterval(checkFinal, 260);
    checkFinal();
  }

  function ensureModal(){
    if (qs(".hp-tib-modal")) return;

    const modal = document.createElement("div");
    modal.className = "hp-tib-modal";
    modal.hidden = true;
    modal.innerHTML = `
      <div class="hp-tib-modal__overlay" data-hp-close></div>
      <div class="hp-tib-modal__card" role="dialog" aria-modal="true" aria-labelledby="hp-tib-modal-title">
        <div class="hp-tib-modal__top">
          <div class="hp-tib-modal__title" id="hp-tib-modal-title">Preview Note</div>
          <button class="hp-tib-modal__close" type="button" aria-label="Schließen" data-hp-close>×</button>
        </div>
        <div class="hp-tib-modal__body">${COPY.tipsHtml}</div>
      </div>
    `;
    document.body.appendChild(modal);

    const close = () => {
      modal.hidden = true;
      document.documentElement.classList.remove("hp-tib-lock");
      document.body.classList.remove("hp-tib-lock");
    };
    const open = () => {
      modal.hidden = false;
      document.documentElement.classList.add("hp-tib-lock");
      document.body.classList.add("hp-tib-lock");
    };

    modal.addEventListener("click", (e) => {
      if (e.target && e.target.closest("[data-hp-close]")) close();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !modal.hidden) close();
    });

    window.__hpTibTipsOpen = open;
    window.__hpTibTipsClose = close;
  }

  function ensureHeaderUI(field){
    const header = field.querySelector(".tee-field__header");
    const heading = header?.querySelector(".tee-field__heading");
    if (!header || !heading) return;

    ensureModal();

    header.querySelectorAll(".hp-tib-headcopy").forEach(n => n.remove());
    header.querySelectorAll(".hp-tib-subline").forEach(n => {
      if (!heading.contains(n)) n.remove();
    });

    if (!heading.querySelector(".hp-tib-tipsinline")) {
      const tips = document.createElement("span");
      tips.className = "hp-tib-tipsinline";
      tips.innerHTML = `
        <span class="hp-tib-tipslabel" role="button" tabindex="0">Preview Note</span>
        <button type="button" class="hp-tib-info" aria-label="Preview Note">i</button>
      `;
      heading.appendChild(tips);

      const open = () => {
        if (typeof window.__hpTibTipsOpen === "function") window.__hpTibTipsOpen();
      };

      tips.querySelector(".hp-tib-info")?.addEventListener("click", open);
      const lbl = tips.querySelector(".hp-tib-tipslabel");
      lbl?.addEventListener("click", open);
      lbl?.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(); }
      });
    }

    let sub = heading.querySelector(".hp-tib-subline");
    if (!sub) {
      sub = document.createElement("div");
      sub.className = "hp-tib-subline";
      sub.textContent = COPY.subline;
      heading.appendChild(sub);
    } else {
      sub.textContent = COPY.subline;
    }
  }

  function openFilePicker(S){
    ACTIVE_STATE = S;
    try { S.els.input.value = ""; } catch(e){}
    try { S.els.input.click(); } catch(e){}
  }

  function openCropperWithRetry(S, {tries=12, delay=120} = {}){
    ACTIVE_STATE = S;

    if (cropperIsOpen()) return true;
    if (!hasAnyPhoto(S)) return false;

    let n = 0;
    const tick = () => {
      n++;
      if (cropperIsOpen()) return;

      const btn = findNativeRecustomizeBtn(S);
      if (btn && nativeRecustomizeUsable(S)) {
        withBypass(() => smartClick(btn, { native:true }));
      }

      if (cropperIsOpen()) return;
      if (n < tries) setTimeout(tick, delay);
    };

    tick();
    return true;
  }

  function bindNativeIntercept(S){
    const field = S.els.field;
    const nativePhotoRoot = field?.querySelector?.(".tee-photo");
    if (!nativePhotoRoot || nativePhotoRoot.__hpInterceptBound) return;
    nativePhotoRoot.__hpInterceptBound = true;

    const handler = (e) => {
      if (!e.isTrusted) return;
      if (BYPASS_NATIVE > 0) return;
      if (e.target && e.target.closest && e.target.closest(".hp-tib-ui")) return;

      const hit = e.target && e.target.closest && e.target.closest(
        ".tee-photo-placeholder, img.tee-photo-image, .tee-photo-label"
      );
      if (!hit) return;

      const now = Date.now();
      const locked = now < (S.interceptLockUntil || 0);

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      if (locked) return;
      S.interceptLockUntil = now + 700;

      ACTIVE_STATE = S;

      if (hasAnyPhoto(S) && nativeRecustomizeUsable(S) && !cropperIsOpen()) {
        openCropperWithRetry(S);
      } else {
        openFilePicker(S);
      }
    };

    nativePhotoRoot.addEventListener("pointerdown", handler, true);
    nativePhotoRoot.addEventListener("mousedown", handler, true);
    nativePhotoRoot.addEventListener("click", handler, true);
  }

  function setAwaitConfirm(S, fileLabel){
    S.phase = "await_confirm";
    clearProcessing(S);

    setPanelState(S, "processing");
    S.els.progress.hidden = false;
    hideResult(S);

    S.els.pickBtn.disabled = true;
    S.els.meta.hidden = false;
    S.els.fileName.textContent = fileLabel || "Photo Selected";
    S.els.hint.textContent = "Please confirm the crop to render the live preview.";

    setProgress(S, 1, CFG.statuses[0]);

    syncAdjustBtn(S);
  }

  function ensureMountedForField(field){
    if (!field) return false;

    let S = STATE.get(field);
    if (!S) { S = makeState(field); STATE.set(field, S); }

    const input =
      field.querySelector(FILE_INPUT_SELECTORS) ||
      field.querySelector('input[type="file"]');

    if (!input) return false;

    S.els.field = field;
    S.els.input = input;

    field.classList.add("hp-tib-mounted");
    ensureHeaderUI(field);
    bindNativeIntercept(S);

    let ui = field.querySelector(".hp-tib-ui");
    const markup = `
      <div class="hp-tib-panel" aria-live="polite">
        <div class="hp-tib-panel-inner">
          <div class="hp-tib-progress" hidden>
            <div class="hp-tib-progress-top">
              <div class="hp-tib-pct">0%</div>
            </div>
            <div class="hp-tib-bar"><div class="hp-tib-barfill"></div></div>
            <div class="hp-tib-status">…</div>
          </div>

          <div class="hp-tib-result" hidden>
            <img class="hp-tib-img" alt="Live-Vorschau" loading="lazy" />
          </div>
        </div>
      </div>

      <div class="hp-tib-actions">
        <button type="button" class="hp-tib-btn hp-tib-btn--primary">
          <span class="hp-tib-ico" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                 stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="17 8 12 3 7 8"/>
              <line x1="12" y1="3" x2="12" y2="15"/>
            </svg>
          </span>
          <span class="hp-tib-btn-text">Upload Photo</span>
        </button>
        <button type="button" class="hp-tib-btn hp-tib-btn--secondary hp-tib-btn-adjust" disabled>
          Adjust Photo
        </button>
      </div>

      <div class="hp-tib-meta">
        <div class="hp-tib-file">No Photo Selected</div>
        <div class="hp-tib-hint"></div>
      </div>
    `;

    if (!ui) {
      ui = document.createElement("div");
      ui.className = "hp-tib-ui";
      ui.dataset.hpTibVersion = "13";
      ui.innerHTML = markup;
    } else if (ui.dataset.hpTibVersion !== "13") {
      ui.dataset.hpTibVersion = "13";
      ui.innerHTML = markup;
    }

    const inputWrap = field.querySelector(".tee-field__input") || field;
    const photo = field.querySelector(".tee-photo");
    if (photo && photo.parentElement) {
      if (ui.parentElement !== photo.parentElement || ui.previousElementSibling !== photo) {
        photo.insertAdjacentElement("afterend", ui);
      }
    } else {
      if (ui.parentElement !== inputWrap) inputWrap.appendChild(ui);
    }

    S.els.ui = ui;

    S.els.panel = ui.querySelector(".hp-tib-panel");
    S.els.progress = ui.querySelector(".hp-tib-progress");
    S.els.status = ui.querySelector(".hp-tib-status");
    S.els.pct = ui.querySelector(".hp-tib-pct");
    S.els.barfill = ui.querySelector(".hp-tib-barfill");
    S.els.result = ui.querySelector(".hp-tib-result");
    S.els.img = ui.querySelector(".hp-tib-img");

    S.els.pickBtn = ui.querySelector(".hp-tib-btn--primary");
    S.els.pickBtnText = ui.querySelector(".hp-tib-btn-text");
    S.els.adjustBtn = ui.querySelector(".hp-tib-btn-adjust");

    S.els.meta = ui.querySelector(".hp-tib-meta");
    S.els.fileName = ui.querySelector(".hp-tib-file");
    S.els.hint = ui.querySelector(".hp-tib-hint");

    if (!S.els.pickBtn.__hpBound) {
      S.els.pickBtn.__hpBound = true;
      S.els.pickBtn.addEventListener("click", () => openFilePicker(S));
    }

    if (!S.els.adjustBtn.__hpBound) {
      S.els.adjustBtn.__hpBound = true;
      S.els.adjustBtn.addEventListener("click", () => {
        if (S.els.adjustBtn.disabled) return;

        ACTIVE_STATE = S;
        S.adjustBroken = false;
        const attempt = ++S.adjustAttempt;

        const ok = openCropperWithRetry(S);

        if (!ok) {
          S.adjustBroken = true;
          syncAdjustBtn(S);
          scheduleAdjustSync(S);
          return;
        }

        setTimeout(() => {
          if (attempt !== S.adjustAttempt) return;
          if (cropperIsOpen()) return;

          if (!nativeRecustomizeUsable(S)) {
            S.adjustBroken = true;
          } else {
            S.adjustBroken = false;
          }

          syncAdjustBtn(S);
          scheduleAdjustSync(S);
        }, 1800);
      });
    }

    if (!S.els.input.__hpBound) {
      S.els.input.__hpBound = true;
      S.els.input.addEventListener("change", () => {
        ACTIVE_STATE = S;

        S.adjustBroken = false;
        const f = S.els.input.files && S.els.input.files[0];
        setAwaitConfirm(S, f ? f.name : "Photo Selected");

        setTimeout(() => {
          syncAdjustBtn(S);
          if (S.phase === "await_confirm" && !cropperIsOpen() && nativeRecustomizeUsable(S)) {
            openCropperWithRetry(S);
          }
        }, 220);
      }, { passive:true });
    }

    if (!S.mounted) {
      const existing = getFieldPhotoUrl(S);
      if (existing) setDone(S, existing);
      else setIdle(S);
      S.mounted = true;
    }

    syncAdjustBtn(S);
    return true;
  }

  function ensureMounted(){
    const fields = document.querySelectorAll(CFG.fieldSelector);
    if (!fields || !fields.length) return false;

    let ok = false;
    fields.forEach(f => { if (ensureMountedForField(f)) ok = true; });
    return ok;
  }

  function pickBestStateFallback(){
    const fields = document.querySelectorAll(CFG.fieldSelector);
    for (const f of fields) {
      const st = STATE.get(f);
      if (st) return st;
    }
    return null;
  }

  function resolveState(){
    return ACTIVE_STATE || pickBestStateFallback();
  }

  function cancelToSafeState(S){
    if (!S) return;
    S.adjustBroken = false;
    S.adjustAttempt++;
    const existing = getFieldPhotoUrl(S) || S.lastFinalUrl;
    if (existing) setDone(S, existing);
    else setIdle(S);
  }

  function boot(){
    ensureMounted();

    let mountRaf = 0;
    const scheduleMount = () => {
      if (mountRaf) return;
      mountRaf = requestAnimationFrame(() => {
        mountRaf = 0;
        ensureMounted();
      });
    };

    const domMo = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type !== "childList") continue;
        if ((m.addedNodes && m.addedNodes.length) || (m.removedNodes && m.removedNodes.length)) {
          scheduleMount();
          break;
        }
      }
    });
    domMo.observe(document.documentElement, { subtree: true, childList: true });

    setInterval(() => ensureMounted(), 2500);

    document.addEventListener("click", (ev) => {
      const root = ev.target?.closest?.(CFG.cropperRootSelector);
      if (!root) return;

      const S = resolveState();
      if (!S) return;

      if (ev.target.closest?.(".tee-dialog-close")) {
        cancelToSafeState(S);
        return;
      }

      if (ev.target.closest?.('.vm--overlay[data-modal="tee-dialog-image-cropper"]') || ev.target.closest?.(".vm--overlay")) {
        cancelToSafeState(S);
        return;
      }

      const btn = ev.target.closest?.("button, [role='button'], .tee-btn");
      if (!btn) return;

      const txt = (btn.textContent || btn.getAttribute("aria-label") || "").trim();

      if (CFG.cancelTextRe.test(txt)) {
        cancelToSafeState(S);
        return;
      }

      if (CFG.confirmTextRe.test(txt)) {
        const baseline = getFieldPhotoUrl(S) || S.lastFinalUrl || "";
        setTimeout(() => startProcessingWithBaseline(S, baseline, "cropper-confirm"), 60);
      }
    }, true);

    document.addEventListener("keydown", (ev) => {
      if (ev.key !== "Escape") return;
      if (!cropperIsOpen()) return;
      const S = resolveState();
      if (!S) return;
      cancelToSafeState(S);
    }, true);

    let wasOpen = false;
    const watchCropperClose = () => {
      const open = cropperIsOpen();
      if (open) {
        wasOpen = true;
        return;
      }
      if (!open && wasOpen) {
        wasOpen = false;
        const S = resolveState();
        if (!S) return;

        scheduleAdjustSync(S);

        if (S.phase === "await_confirm") {
          const before = getFieldPhotoUrl(S) || S.lastFinalUrl || "";
          setTimeout(() => {
            const after = getFieldPhotoUrl(S) || S.lastFinalUrl || "";
            if (!after || after === before) {
              cancelToSafeState(S);
            }
          }, 120);
        }
      }
    };

    const portal = document.getElementById("tib-portal-root") || document.body;
    const cropMo = new MutationObserver(() => watchCropperClose());
    cropMo.observe(portal, { subtree:true, childList: true, attributes:true, attributeFilter:["aria-expanded","style","class"] });
    setInterval(watchCropperClose, 350);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once:true });
  } else {
    boot();
  }
})();